/**
 * email field validation conforming to RFC 5322
 * @param {String} val - String value sent from field
 */
export const emailValidation = (val) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (val.length <= 0 || !regex.test(val)) {
    return false
  }

  return true
}

/**
 * Phone number field validation
 * @param {String} val - String value sent from field
 * @usage VALID_SMS_NUMBER.test(value)
 */
export const VALID_SMS_NUMBER = /^[0-9+\-*() ]*$/

/**
 * Email field validation for multiple emails separated by commas
 * @param {String} val - String value sent from field
 * @usage VALID_EMAIL.test(value)
 */
export const VALID_EMAIL =
  /^(\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}\s*,)*\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}\s*$/
